import shop from "@/api/payments";
import {
    authenticationService
} from '@/_services';
// initial state
const state = {
    all: [],
    Payment: {},
    hbGroup: [],
    selectedPayments: [],
    transactionTypes: [
        {text: "Tümü", value: -1},
        {text: "Hizmet Bedeli", value: 0},
        {text: "Sipariş tutarı", value: 1},
        {text: "MP Stopaj", value: 2},
        {text: "Kargo Bedeli", value: 3},
        {text: "Komisyon", value: 4},
        {text: "İade tutarı", value: 5},
        {text: "Stopaj İade", value: 6},
        {text: "Kampanya İndirim", value: 7},
        {text: "Komisyon İade", value: 8},
        {text: "Altın İşçilik Bedeli Stopaj", value: 9},
        {text: "Müşteri Memnuniyeti", value: 10},
        {text: "Sevkiyat Maliyeti Paylaşımı Gelir", value: 11},
        {text: "Faturalandırılacak Tutar", value: 1000},
        
    ],
    transactionStatus: [
        {text: "Tümü", value: -1},
        {text: "Ödeme Bekleniyor", value: 0},
        {text: "Ödendi", value: 1},
        {text: "Fark Olanlar", value: 2},
    ],

};
// getters
const getters = {
    Payment: state => {
        return state.Payment;
    },
    getStateItems: state => {
        return state.stateItems.find(el => el.id == authenticationService.currentUserValue.tenantId).states;
    },
};

// actions
const actions = {
    getAllPayments({
        commit
    }) {
        shop.getPayments().then(Payments => {
            commit("getPayments", Payments.data);
        });
    },
    hbStatusGroup: async (context, Order) => {
        let d = (await shop.hbStatusGroup(Order)).data;
        context.commit("getHbStatusGroup", d);
        return d;
    },
    searchPayment: async (context, Payment) => {
        let d = (await shop.searchPayment(Payment)).data;
        context.commit("getPayments", d);
        return d;
    },
    getPayment: async (context, id) => {
        let d = (await shop.getPayment(id)).data;
        context.commit("getPayment", d);
        return d;
    },
    postPayment: async (context, Payment) => {
        const result = (await shop.postPayment(Payment)).data;
        context.commit("postPayment", result);
    },
    putPayment: async (context, Payment) => {
        const result = (await shop.putPayment(Payment)).data;
        context.commit("putPayment", result);
    },
    deletePayment: async (context, Payment) => {
        const result = (await shop.deletePayment(Payment)).data;
        // eslint-disable-next-line no-console
        console.log(result);
        context.commit("deletePayment", Payment);
    },
    bulkUpdateStates: async (context, model) => {
        const result = (await shop.bulkUpdateStates(model)).data;
        // eslint-disable-next-line no-console
        context.commit("bulkUpdateStates", model);
    },
    saveInsurance: async (context, model) => {
        const result = (await shop.saveInsurance(model)).data;
    },
    uploadInsurance: async (context, model) => {
        return (await shop.uploadInsurance(model)).data;
    },
    reSendInvoice: async (context, model) => {
        const result = (await shop.reSendInvoice(model)).data;
        // // eslint-disable-next-line no-console
        // context.commit("reSendInvoice", model);
    }
};

// mutations
const mutations = {
    getPayments(state, Payments) {
        state.all = Payments;
    },
    setSelectedPayments(state, Payments) {
        state.selectedPayments = Payments;
    },
    getPayment(state, Payment) {
        //state.Payment = Payment
        state.Payment = null;
        state.Payment = Object.assign({}, state.Payment, Payment);
    },
    postPayment(state, Payment) {
        //state.Payment = Payment
        state.Payment = null;
        state.Payment = Object.assign({}, state.Payment, Payment);
    },
    putPayment(state, Payment) {
        //state.Payment = Payment
        state.Payment = null;
        state.Payment = Object.assign({}, state.Payment, Payment);
    },

    getHbStatusGroup(state, Orders) {
        state.hbGroup= Orders;
    },
    deletePayment(state, Payment) {
        state.all.splice(state.all.indexOf(Payment), 1);
    },
    bulkUpdateStates(state, model) {
        // const data = model.selecteItems.map(({ id }) => id);
        model.selectedItems.map(item => {
            item.state = model.stateId;
            return item;
        })
        console.log(model.selectedItems);
        state.all = Object.assign({}, state.all, model.selectedItems);

        // state.all.splice(state.all.indexOf(Payment), 1);
    },
    decrementPaymentInventory(state, {
        id
    }) {
        const Payment = state.all.find(Payment => Payment.id === id);
        Payment.inventory--;
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};